import React from 'react';
import { StoreContainer } from '../../container';

const StorePage = () => {
  return (
    <>
      <StoreContainer />
    </>
  );
};

export default StorePage;
